import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "avatar-selector-wrapper" };
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 2,
    class: "edit-overlay"
};
const _hoisted_4 = { class: "avatar-editor-panel parchment-panel" };
const _hoisted_5 = { class: "editor-body" };
const _hoisted_6 = { class: "preview-column" };
const _hoisted_7 = { class: "preview-avatar" };
const _hoisted_8 = ["src"];
const _hoisted_9 = {
    key: 1,
    class: "preview-text"
};
const _hoisted_10 = {
    key: 1,
    class: "preview-placeholder"
};
const _hoisted_11 = { class: "input-column" };
const _hoisted_12 = { class: "input-group" };
const _hoisted_13 = { class: "file-input-wrapper" };
const _hoisted_14 = ["title"];
const _hoisted_15 = { class: "input-group" };
const _hoisted_16 = { class: "input-group" };
import { computed, ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AvatarSelector',
    props: {
        modelValue: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '?',
        },
        editable: {
            type: Boolean,
            default: false,
        },
        shape: {
            type: String,
            default: 'square',
        },
        fontSize: {
            type: String,
            default: '3rem',
        },
    },
    emits: ['update:modelValue', 'change'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // 状态
        const isEditorOpen = ref(false);
        const previewValue = ref('');
        const urlInput = ref('');
        const emojiInput = ref('');
        const selectedFileName = ref('');
        const imageLoadError = ref(false);
        const previewLoadError = ref(false);
        const fileInputRef = ref(null);
        // 显示值
        const displayValue = computed(() => props.modelValue || '');
        // 判断是否为图片链接
        const isImageUrl = (val) => {
            if (!val)
                return false;
            return /^(https?:\/\/|data:image\/|blob:|\/|\.\/)/.test(val);
        };
        // 处理图片加载失败
        const handleImageError = () => {
            imageLoadError.value = true;
        };
        const handlePreviewError = () => {
            previewLoadError.value = true;
        };
        // 监听 modelValue 变化
        watch(() => props.modelValue, () => {
            imageLoadError.value = false;
        });
        // 打开编辑器
        const openEditor = () => {
            if (!props.editable)
                return;
            // 初始化编辑器状态
            previewValue.value = props.modelValue;
            urlInput.value = isImageUrl(props.modelValue) ? props.modelValue : '';
            emojiInput.value = !isImageUrl(props.modelValue) ? props.modelValue : '';
            selectedFileName.value = '';
            previewLoadError.value = false;
            isEditorOpen.value = true;
        };
        // 触发文件选择
        const triggerFileInput = () => {
            fileInputRef.value?.click();
        };
        /**
         * 压缩图片
         * @param file 原始图片文件
         * @param maxSize 最大尺寸（宽或高）
         * @param quality JPEG 压缩质量 (0-1)
         */
        const compressImage = (file, maxSize = 256, quality = 0.8) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                const reader = new FileReader();
                reader.onload = e => {
                    img.src = e.target?.result;
                };
                img.onload = () => {
                    // 计算缩放后的尺寸
                    let { width, height } = img;
                    if (width > height) {
                        if (width > maxSize) {
                            height = Math.round((height * maxSize) / width);
                            width = maxSize;
                        }
                    }
                    else if (height > maxSize) {
                        width = Math.round((width * maxSize) / height);
                        height = maxSize;
                    }
                    // 使用 Canvas 压缩
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    if (!ctx) {
                        reject(new Error('无法创建 Canvas 上下文'));
                        return;
                    }
                    ctx.drawImage(img, 0, 0, width, height);
                    // 转换为压缩后的 Base64 (使用 JPEG 格式压缩更好)
                    const compressedBase64 = canvas.toDataURL('image/jpeg', quality);
                    resolve(compressedBase64);
                };
                img.onerror = () => reject(new Error('图片加载失败'));
                reader.onerror = () => reject(new Error('文件读取失败'));
                reader.readAsDataURL(file);
            });
        };
        // 处理文件选择
        const handleFileSelect = async (event) => {
            const input = event.target;
            const file = input.files?.[0];
            if (file) {
                selectedFileName.value = file.name;
                try {
                    // 压缩图片后转为 Base64
                    const compressedBase64 = await compressImage(file, 256, 0.8);
                    previewValue.value = compressedBase64;
                    urlInput.value = '';
                    emojiInput.value = '';
                    previewLoadError.value = false;
                }
                catch (err) {
                    console.error('图片压缩失败:', err);
                    // 失败时回退到原始方式
                    const reader = new FileReader();
                    reader.onload = e => {
                        previewValue.value = e.target?.result;
                        urlInput.value = '';
                        emojiInput.value = '';
                        previewLoadError.value = false;
                    };
                    reader.readAsDataURL(file);
                }
            }
        };
        // 处理 URL 输入
        const handleUrlInput = () => {
            if (urlInput.value.trim()) {
                previewValue.value = urlInput.value.trim();
                emojiInput.value = '';
                selectedFileName.value = '';
                previewLoadError.value = false;
            }
        };
        // 处理 Emoji 输入
        const handleEmojiInput = () => {
            if (emojiInput.value) {
                previewValue.value = emojiInput.value;
                urlInput.value = '';
                selectedFileName.value = '';
            }
        };
        // 确认编辑
        const confirmEdit = () => {
            if (previewValue.value !== props.modelValue) {
                emit('update:modelValue', previewValue.value);
                emit('change', previewValue.value);
            }
            isEditorOpen.value = false;
        };
        // 取消编辑
        const cancelEdit = () => {
            isEditorOpen.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" 头像显示区域，点击打开编辑面板 "),
                _createElementVNode("div", {
                    class: _normalizeClass(["avatar-trigger", [__props.shape, { 'is-editable': __props.editable }]]),
                    onClick: openEditor
                }, [
                    (displayValue.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (isImageUrl(displayValue.value))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: displayValue.value,
                                    class: "avatar-img",
                                    alt: "Avatar",
                                    onError: handleImageError
                                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: "avatar-text",
                                    style: _normalizeStyle({ fontSize: __props.fontSize })
                                }, _toDisplayString(displayValue.value), 5 /* TEXT, STYLE */))
                        ], 64 /* STABLE_FRAGMENT */))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "avatar-placeholder",
                            style: _normalizeStyle({ fontSize: __props.fontSize })
                        }, _toDisplayString(__props.placeholder), 5 /* TEXT, STYLE */)),
                    _createCommentVNode(" 编辑提示遮罩 "),
                    (__props.editable)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("span", { class: "edit-icon" }, "✏️", -1 /* CACHED */)
                            ]))]))
                        : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */),
                _createCommentVNode(" 编辑面板（弹窗） "),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(() => [
                            (isEditorOpen.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "avatar-editor-backdrop",
                                    onClick: _withModifiers(cancelEdit, ["self"])
                                }, [
                                    _createCommentVNode(" 羊皮纸风格面板 "),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createCommentVNode(" 装饰性边角 "),
                                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "corner corner-tl" }, null, -1 /* CACHED */)),
                                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "corner corner-tr" }, null, -1 /* CACHED */)),
                                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "corner corner-bl" }, null, -1 /* CACHED */)),
                                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "corner corner-br" }, null, -1 /* CACHED */)),
                                        _createElementVNode("div", { class: "editor-header" }, [
                                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "editor-title" }, [
                                                _createElementVNode("i", { class: "fas fa-feather-alt" }),
                                                _createTextVNode(" 肖像设置 ")
                                            ], -1 /* CACHED */)),
                                            _createElementVNode("button", {
                                                class: "close-btn",
                                                title: "关闭",
                                                onClick: cancelEdit
                                            }, "✕")
                                        ]),
                                        _createElementVNode("div", _hoisted_5, [
                                            _createCommentVNode(" 左侧：预览区域 "),
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["preview-frame", __props.shape])
                                                }, [
                                                    _createElementVNode("div", _hoisted_7, [
                                                        (previewValue.value)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                (isImageUrl(previewValue.value))
                                                                    ? (_openBlock(), _createElementBlock("img", {
                                                                        key: 0,
                                                                        src: previewValue.value,
                                                                        class: "preview-img",
                                                                        alt: "Preview",
                                                                        onError: handlePreviewError
                                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_8))
                                                                    : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(previewValue.value), 1 /* TEXT */))
                                                            ], 64 /* STABLE_FRAGMENT */))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(__props.placeholder), 1 /* TEXT */))
                                                    ])
                                                ], 2 /* CLASS */),
                                                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "preview-caption" }, "当前预览", -1 /* CACHED */))
                                            ]),
                                            _createCommentVNode(" 右侧：输入区域 "),
                                            _createElementVNode("div", _hoisted_11, [
                                                _createCommentVNode(" 本地导入 "),
                                                _createElementVNode("div", _hoisted_12, [
                                                    _cache[6] || (_cache[6] = _createElementVNode("label", { class: "input-label" }, "本地图册（不推荐）", -1 /* CACHED */)),
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _createElementVNode("input", {
                                                            ref_key: "fileInputRef",
                                                            ref: fileInputRef,
                                                            type: "file",
                                                            accept: "image/*",
                                                            class: "file-input",
                                                            onChange: handleFileSelect
                                                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                                                        _createElementVNode("button", {
                                                            class: "parchment-btn small",
                                                            onClick: triggerFileInput
                                                        }, [...(_cache[5] || (_cache[5] = [
                                                                _createElementVNode("i", { class: "fas fa-folder-open" }, null, -1 /* CACHED */),
                                                                _createTextVNode(" 选择图片 ", -1 /* CACHED */)
                                                            ]))]),
                                                        (selectedFileName.value)
                                                            ? (_openBlock(), _createElementBlock("span", {
                                                                key: 0,
                                                                class: "file-name",
                                                                title: selectedFileName.value
                                                            }, _toDisplayString(selectedFileName.value), 9 /* TEXT, PROPS */, _hoisted_14))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ]),
                                                _createCommentVNode(" 装饰分割线 "),
                                                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "divider-line" }, null, -1 /* CACHED */)),
                                                _createCommentVNode(" 网络链接 "),
                                                _createElementVNode("div", _hoisted_15, [
                                                    _cache[7] || (_cache[7] = _createElementVNode("label", { class: "input-label" }, "网络链接", -1 /* CACHED */)),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((urlInput).value = $event)),
                                                        type: "text",
                                                        class: "parchment-input",
                                                        placeholder: "https://...",
                                                        onInput: handleUrlInput
                                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                        [_vModelText, urlInput.value]
                                                    ])
                                                ]),
                                                _createCommentVNode(" 装饰分割线 "),
                                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "divider-line" }, null, -1 /* CACHED */)),
                                                _createCommentVNode(" Emoji 输入 "),
                                                _createElementVNode("div", _hoisted_16, [
                                                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "input-label" }, "文字标识", -1 /* CACHED */)),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((emojiInput).value = $event)),
                                                        type: "text",
                                                        class: "parchment-input text-center",
                                                        placeholder: "例如: 🧙‍♂️",
                                                        maxlength: "4",
                                                        onInput: handleEmojiInput
                                                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                        [_vModelText, emojiInput.value]
                                                    ])
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", { class: "editor-footer" }, [
                                            _createElementVNode("button", {
                                                class: "parchment-btn-text",
                                                onClick: cancelEdit
                                            }, "暂不修改"),
                                            _createElementVNode("button", {
                                                class: "parchment-btn primary",
                                                onClick: confirmEdit
                                            }, [...(_cache[11] || (_cache[11] = [
                                                    _createElementVNode("span", { class: "btn-text" }, "确认更改", -1 /* CACHED */)
                                                ]))])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]))
            ]));
        };
    }
});
